import Button from '@atoms/Button/Button';
import { ISocialLinks } from '@models/ISocialLinks';

const SocialLinks = ({
  links,
  copyToClipboardLabel,
  onCopyToClipboard,
}: ISocialLinks) => (
  <div className="tw-flex tw-gap-2">
    {links.map(({ target, linkIcon, url, text }) => (
      <Button
        as="link"
        key={text}
        aria-label={text}
        modifier="outline"
        variant="grey30"
        href={url}
        iconName={linkIcon}
        iconSize="1.5rem"
        buttonClasses="!tw-p-0 tw-h-xl tw-w-xl"
        iconClasses="tw-text-2xl"
        target={target}
      />
    ))}
    {copyToClipboardLabel && onCopyToClipboard && (
      <Button
        onClick={() => {
          window.navigator.clipboard.writeText(window.location.href);
          onCopyToClipboard();
        }}
        aria-label={copyToClipboardLabel}
        modifier="outline"
        variant="grey30"
        iconName="link"
        iconSize="1.5rem"
        buttonClasses="!tw-p-0 tw-h-xl tw-w-xl"
        iconClasses="tw-text-2xl"
      />
    )}
  </div>
);

export default SocialLinks;
